(function () {
  'use strict';

  document.querySelectorAll('[data-smile-family]').forEach(function (section) {
    var track = section.querySelector('.sfam__track');
    var group = section.querySelector('.sfam__group');
    var toggle = section.querySelector('[data-sfam-toggle]');

    if (!track || !group || track.children.length > 1) return;

    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.querySelectorAll('img').forEach(function (img) {
      img.alt = '';
    });
    track.appendChild(clone);

    var loadCarouselImages = function () {
      section.querySelectorAll('img').forEach(function (img) {
        img.loading = 'eager';
      });
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        loadCarouselImages();
        observer.disconnect();
      }, { rootMargin: '600px 0px' });
      observer.observe(section);
    } else {
      loadCarouselImages();
    }

    if (!toggle) return;
    toggle.addEventListener('click', function () {
      var paused = section.classList.toggle('is-paused');
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.textContent = paused ? 'Relancer le défilement' : 'Mettre en pause';
    });
  });
})();
